/*
    Главная страница
*/

import {throttle} from './ThrottleDebounce';

/*const $mainProjectLink = $('.js-main-project-link');
const $mainProjectItems = $('.js-main-project-item');
const $projectNavigation = $('.js-project-navigation');*/

/*if (!App.mobile) {
    App.H.find('.js-main-project-link').on('mouseenter', throttle(projectHover, 10));

    setTimeout(function () {
        $('.js-main-project-link').filter(`[data-project="0"]`).trigger('mouseenter');
        $('.js-main-project-item').filter(`[data-project="0"]`).addClass('_hover');
    }, 500);
}*/

/*function projectHover() {
    let $currProject = $(this);
    let currProjectIndex = $currProject.data('project');

    $('.js-main-project-link').removeClass('_hover');
    $currProject.addClass('_hover');

    $('.js-main-project-item')
        .removeClass('_hover')
        .filter(`[data-project="${currProjectIndex}"]`)
        .addClass('_hover');
}*/

/*
export function mainSlider() {
    setTimeout(function () {
        $('.js-main-project-link').eq(0).trigger('mouseenter');
        $('.js-main-project-item').eq(0).addClass('_hover');
    }, 200);
}*/



// WEBPACK FOOTER //
// ./_src/js/modules/PageMain.js